import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";


export default function MainRadio({
    label,
    value,
    onChange,
    options,
    direction = "row"
}) {

    const { mode } = useColorScheme();
    const currentMode = mode || "system";

    return (
        <FormControl>
            {label && <Typography
                sx={{
                    color: Constants.Colors[currentMode].mutedForeground,
                    fontSize: Constants.Styles.fontSize.xs,
                    lineHeight: Constants.Styles.lineHeight.xs,
                }}
            >{label}</Typography>}
            <RadioGroup
                row={direction === "row"}
                value={value}
                onChange={onChange}
            >
                {options.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio
                            sx={{
                                '& .MuiSvgIcon-root': {
                                    fontSize: 20,
                                },
                            }}
                        />}
                        label={<Typography
                            sx={{
                                color: Constants.Colors[currentMode].foreground,
                                fontSize: Constants.Styles.fontSize.xs,
                                lineHeight: Constants.Styles.lineHeight.xs,
                            }}
                        >{option.label}</Typography>}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
}